module.exports = __webpack_public_path__ + "img/weixin.80c480df.svg";